import { registerTypes } from './config'
import { AccountsPageType, RegisterType } from './types'

const getAccountsDomainFromCurrent = (): string | undefined => {
  const currentDomain = typeof window !== 'undefined' ? window.location.origin : ''
  const regex = /(https:\/\/)[\w-]+\.(designsforhealth\.(com|ca)|dfh\.dev)/
  if (!regex.test(currentDomain)) {
    return undefined
  }
  const accountsDomain = currentDomain.replace(regex, '$1accounts.$2')
  if (accountsDomain === currentDomain) {
    return undefined
  }
  return accountsDomain
}

export const getAccountsUrl = (): string => {
  const accountsUrlEnv = process.env.GATSBY_ACCOUNTS_URL
  const accountsUrlDefault = getAccountsDomainFromCurrent()
  const accountsUrl = `${accountsUrlEnv || accountsUrlDefault || ''}`
  return `${accountsUrl}${accountsUrl.endsWith('/') ? '' : '/'}`
}

export const getAccountsCheckoutUrl = (): string => {
  const accountsUrl = getAccountsUrl()
  return `${accountsUrl}checkout/`
}

export const getAccountsRegisterUrl = (): string => {
  const accountsUrl = getAccountsUrl()
  return `${accountsUrl}register/`
}

export const isRegisterType = (type: string): type is RegisterType =>
  registerTypes.includes(type as RegisterType)

export const getAccountsUrlForPage = (page: AccountsPageType | undefined): string => {
  switch (page) {
    case 'checkout':
      return getAccountsCheckoutUrl()
    case 'register':
      return getAccountsRegisterUrl()
    default:
      return getAccountsUrl()
  }
}
